// extracted by mini-css-extract-plugin
export var cardTitle = "_ha-1";
export var commentBubble = "_ha-e";
export var commentForm = "_ha-a";
export var commentInput = "_ha-b";
export var commentLabel = "_ha-d";
export var commentPrompt = "_ha-9";
export var csatCard = "_ha-0";
export var feedbackSection = "_ha-7";
export var starDisabled = "_ha-6";
export var starEmpty = "_ha-5";
export var starFilled = "_ha-4";
export var starWrapper = "_ha-3";
export var starsContainer = "_ha-2";
export var submittedComment = "_ha-c";
export var thankYouText = "_ha-8";